import mutations from "../mutations";

export default {
  namespaced: true,
  state: {
    userData: {},
  },
  mutations,
  actions: {
    getUserInformation({ commit }) {
      return new Promise((res) => {
        commit("setState", { key: "userData", value: {
          dates: [
            // {
            //   place: "Drogeria fernando",
            //   src: "https://kaikucaffelatte.com/blog/wp-content/uploads/2020/03/shutterstock_510679489-scaled.jpg",
            //   address: "Calle 40 sur # 45 c 15",
            //   phone: "315 45 45 54",
            // },
            // {
            //   place: "Drogeria Marta",
            //   address: "Calle 40 sur # 45 c 15 Calle 40 sur # 45 c 15 Calle 40 sur # 45 c 15 Calle 40 sur # 45 c 15",
            //   phone: "315 45 54",
            // },
            // {
            //   place: "Drogeria fernando Drogeria Marta Drogeria Marta Drogeria Marta Drogeria Marta Drogeria Marta",
            //   src: "https://kaikucaffelatte.com/blog/wp-content/uploads/2020/03/shutterstock_510679489-scaled.jpg",
            //   address: "Calle 41 norte 45 c",
            //   phone: "316 45 45 599",
            // },
            // {
            //   place: "Drogeria fernando",
            //   src: "https://kaikucaffelatte.com/blog/wp-content/uploads/2020/03/shutterstock_510679489-scaled.jpg",
            //   address: "Calle 40 sur # 17 c 23",
            //   phone: "316 45 45 98",
            //   confirmation: true,
            // },
            // {
            //   place: "Drogeria fernando",
            //   src: "https://kaikucaffelatte.com/blog/wp-content/uploads/2020/03/shutterstock_510679489-scaled.jpg",
            //   address: "Calle 40 sur # 23 c 15",
            //   phone: "316 45 48 54 316 45 48 54 316 45 48 54 316 45 48 54 316 45 48 54 316 45 48 54 316 45 48 54",
            // },
          ],
        }, });
        res("Ok");
      });
    },
  },
};
